<div class="bary-table-list table-responsive">
  <table mdbTable [hover]="true" [small]="true">
    <thead>
      <tr [(ascending)]="pagination.reverse" [(predicate)]="pagination.predicate" (sortChange)="transition()" jhiSort>
        <th jhiSortBy="name">
          <span jhiTranslate="merchandises.list.name">Name</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th><span jhiTranslate="merchandises.list.offer">Offers</span></th>
        <th><span jhiTranslate="merchandises.list.forceQuotation">Force quotation</span></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let merchandise of sortByName(); let index = index">
        <td>
          <span class="no-capitalize">{{ merchandise.oldName }}</span>
        </td>
        <td>
          <mdb-badge class="m-1" [primary]="true" *ngFor="let offer of merchandise.offers">{{ offer.name }}</mdb-badge>
        </td>
        <td>
          <jhi-bary-input-switch
            [disabled]="false"
            [onLabel]="'sur devis'"
            *ngIf="merchandise.forceQuotation"
            [value]="true"
            (onChangeEvent)="changeActif($event, merchandise)"
          ></jhi-bary-input-switch>
          <jhi-bary-input-switch [disabled]="false" *ngIf="!merchandise.forceQuotation" [value]="false" (onChangeEvent)="changeActif($event, merchandise)"></jhi-bary-input-switch>
        </td>
        <td>
          <div class="d-flex justify-content-end">
            <a (click)="rename(merchandise)" [mdbTooltip]="'entity.action.rename' | translate" mdbBtn [floating]="true" [outline]="true" size="sm" color="primary">
              <mdb-icon fas icon="pencil-alt"></mdb-icon>
            </a>
            <a (click)="joinOffers(merchandise)" [mdbTooltip]="'entity.action.attribute' | translate" mdbBtn [floating]="true" [outline]="true" size="sm" color="primary">
              <mdb-icon fas icon="clipboard-check"></mdb-icon>
            </a>
            <a [mdbTooltip]="'entity.action.delete' | translate" mdbBtn [floating]="true" size="sm" color="primary" (click)="deleteMerchandise(merchandise)">
              <mdb-icon fas icon="times"></mdb-icon>
            </a>
          </div>
        </td>
      </tr>
      <tr *ngIf="!isHidden()" class="text-center">
        <td colspan="7" class="table-data-not-found">
          <div class="text-center">
            <p class="lead p-5" jhiTranslate="merchandises.list.noData">No Merchandises</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
